import { useState } from "react";
import { galleryImages } from "../data/gallery";
import { motion } from "framer-motion";

export default function GallerySection() {
  const [activeImage, setActiveImage] = useState(null);

  return (
    <section
      id="gallery"
      className="py-32 bg-royal-light dark:bg-royal-dark scroll-mt-24"
    >
      <div className="max-w-7xl mx-auto px-6">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="relative inline-block">
            <span className="absolute inset-0 blur-3xl bg-gold/10 rounded-full"></span>
            <h2 className="relative text-4xl font-serif text-gold">
              Gallery
            </h2>
          </div>

          <p className="mt-4 text-charcoal/70 dark:text-ivory/70 max-w-2xl mx-auto">
            A glimpse into the refined spaces and serene ambience of
            M R Suites Dharwad.
          </p>
        </motion.div>

        {/* Masonry Grid */}
        <div className="columns-1 sm:columns-2 md:columns-3 gap-6 space-y-6">
          {galleryImages.map((img, index) => (
            <motion.img
              key={index}
              src={img}
              alt={`Gallery ${index + 1}`}
              className="w-full rounded-3xl cursor-pointer shadow-lg hover:shadow-xl transition"
              whileHover={{ scale: 1.02 }}
              onClick={() => setActiveImage(img)}
            />
          ))}
        </div>

      </div>

      {/* Lightbox */}
      {activeImage && (
        <div
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-6"
          onClick={() => setActiveImage(null)}
        >
          <motion.img
            src={activeImage}
            alt="Preview"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className="max-h-[90vh] rounded-2xl shadow-2xl"
          />
        </div>
      )}
    </section>
  );
}